// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kk-3";
export var downloadButton = "_kk-4";
export var fileContainer = "_kk-9 _kk-7";
export var fileContainerBase = "_kk-7";
export var fileContainerBaseSm = "_kk-a _kk-7";
export var fileContainerFixedHeight = "_kk-8 _kk-7";
export var fileContainerFixedHeightSm = "_kk-c _kk-a _kk-7";
export var fileContainerSm = "_kk-b _kk-a _kk-7";
export var fileInfo = "_kk-5";
export var fileInfoWidthRestricted = "_kk-6";
export var fileType = "_kk-1";
export var fileTypeName = "_kk-2";
export var fileTypeSm = "_kk-d _kk-1";
export var image = "_kk-0";
export var link = "_kk-f";
export var overflowEllipsis = "_kk-e";